module.exports = "/_next/static/images/a7a3924a47cef5eff8d386e831c12edc-cucuta-perks-xs-2x.jpg";